export { default as PostInfo } from './PostInfo';
